/* Myntra-style hover autoplay for product card images (color-aware v6) */
(function () {
  'use strict';

  var VERSION = '6';
  var AUTOPLAY_MS = 900;
  var DEBUG = true; /* <- set to false once confirmed working */
  var active = null;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CARD_SELECTOR = '.product-card, .card-wrapper, .product-card-wrapper, .spf-product-card, .spf-productcard, .product-item, .grid-product__content';

  console.log('[card-slider] v' + VERSION + ' loaded on ' + location.pathname);

  /* Guarantee slider CSS exists on every page (collections included) */
  if (!document.getElementById('card-slider-css')) {
    var css = document.createElement('style');
    css.id = 'card-slider-css';
    css.textContent = [
      '.card-media-host{position:relative}',
      '.card-media-slider{position:absolute;inset:0;z-index:2;overflow:hidden;opacity:0;transition:opacity .25s ease;pointer-events:none}',
      '.card-media-slider.is-on,.product-card:hover .card-media-slider{opacity:1}',
      '.card-media-track{display:flex;height:100%;transition:transform .5s ease}',
      '.card-media-slide{display:block;flex:0 0 100%;width:100%;height:100%;object-fit:cover}',
      '.card-media-dots{position:absolute;left:0;right:0;bottom:10px;display:flex;justify-content:center;gap:5px}',
      '.card-media-dot{width:5px;height:5px;border-radius:50%;background:rgba(255,255,255,.65);box-shadow:0 0 3px rgba(0,0,0,.4)}',
      '.card-media-dot.is-active{background:#fff}',
      '@media (hover: none){.card-media-slider{display:none}}'
    ].join('');
    document.head.appendChild(css);
  }

  function log() {
    if (DEBUG && console.log) {
      console.log.apply(console, ['[card-slider]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  /* ---------- card detection (works with any theme/app markup) ---------- */

  function findCard(el) {
    if (!el || !el.closest) return null;
    var c = el.closest(CARD_SELECTOR);
    if (c) return c;

    var link = el.closest('a[href*="/products/"]');
    if (!link) return null;
    c = link;
    while (c && c !== document.body) {
      var r = c.getBoundingClientRect();
      if (c.querySelector('img') && r.width > 100 && r.height > 100) return c;
      c = c.parentElement;
    }
    return link;
  }

  function mediaHost(card) {
    var m = card.querySelector('.product-card__media, .card__media, .card-media, .spf-product-card__media');
    if (m) return m;
    var img = card.querySelector('img');
    if (img) {
      var p = img.parentElement;
      while (p && p !== card) {
        if (p.offsetWidth > 50 && p.offsetHeight > 50) return p;
        p = p.parentElement;
      }
      return img.parentElement || card;
    }
    return card;
  }

  /* ---------- generic helpers ---------- */

  function visibleSlides(track) {
    return Array.prototype.filter.call(track.children, function (slide) {
      return slide.style.display !== 'none';
    });
  }

  function slideColors(track) {
    return Array.prototype.map.call(track.children, function (s) {
      return s.getAttribute('data-color');
    });
  }

  function buildDots(card, count) {
    var wrap = card.querySelector('.card-media-dots');
    if (!wrap) return [];
    wrap.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'card-media-dot' + (i === 0 ? ' is-active' : '');
      wrap.appendChild(dot);
    }
    return Array.prototype.slice.call(wrap.children);
  }

  function clearDots(card) {
    var wrap = card.querySelector('.card-media-dots');
    if (wrap) wrap.innerHTML = '';
  }

  function baseName(u) {
    if (!u) return '';
    var p = String(u).split('?')[0].split('#')[0];
    var segs = p.split('/');
    return segs[segs.length - 1].toLowerCase();
  }

  function imgUrl(im) {
    if (!im) return '';
    return (typeof im === 'string') ? im : (im.src || im.url || '');
  }

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var parts = (a.getAttribute('href') || '').split('/products/');
    if (parts.length < 2) return '';
    return parts[1].split('?')[0].split('#')[0].replace(/\/+$/, '');
  }

  function colorIndexFromOptions(options) {
    var kws = ['color', 'colour', 'shade'];
    if (!options || !options.length) return 0;
    for (var i = 0; i < options.length; i++) {
      var o = options[i];
      /* .js endpoint gives objects ({name, values}); Liquid gives strings */
      var n = (typeof o === 'string') ? o : (o && o.name) ? String(o.name) : '';
      n = n.toLowerCase();
      for (var j = 0; j < kws.length; j++) {
        if (n.indexOf(kws[j]) !== -1) return i + 1;
      }
    }
    return 0;
  }

  function variantColor(v, idx) {
    if (idx === 1) return v.option1;
    if (idx === 2) return v.option2;
    if (idx === 3) return v.option3;
    return '';
  }

  function fetchProduct(handle, cb) {
    if (!window.__cardSliderCache) window.__cardSliderCache = {};
    if (window.__cardSliderCache[handle]) return cb(window.__cardSliderCache[handle]);
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.handle) window.__cardSliderCache[handle] = p;
        cb(p || null);
      })
      .catch(function () { cb(null); });
  }


  function buildSlider(card, product) {
    if (card.querySelector('.card-media-slider')) return true;
    var images = (product.images || []).map(imgUrl).filter(Boolean);
    if (images.length < 2) return false;

    var colorIdx = colorIndexFromOptions(product.options || []);
    var variants = product.variants || [];

    var firstAvail = null, i, j;
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) { firstAvail = variants[i]; break; }
    }
    if (!firstAvail && variants.length) firstAvail = variants[0];

    var defaultColor = firstAvail ? (variantColor(firstAvail, colorIdx) || '').toLowerCase().trim() : '';
    var canFilter = colorIdx > 0 && defaultColor !== '';

    /* map every image -> its color (carry-forward, identical to the Liquid
       snippet): an image belongs to the color of the variant whose featured
       image it is; unassigned images keep the color of the image before them,
       so each color group gets its own share of the shoot images */
    var colors = [];
    var current = defaultColor;
    for (i = 0; i < images.length; i++) {
      var nb = baseName(images[i]);
      for (j = 0; j < variants.length; j++) {
        if (baseName(imgUrl(variants[j].featured_image)) === nb) {
          var c = (variantColor(variants[j], colorIdx) || '').toLowerCase().trim();
          if (c) current = c;
        }
      }
      colors.push(current);
    }

    var host = mediaHost(card);
    if (getComputedStyle(host).position === 'static') host.classList.add('card-media-host');

    var slider = document.createElement('div');
    slider.className = 'card-media-slider';
    slider.setAttribute('aria-hidden', 'true');
    slider.setAttribute('data-color-option', String(colorIdx));
    slider.setAttribute('data-default-color', defaultColor);
    if (!canFilter) slider.setAttribute('data-no-filter', 'true');

    var track = document.createElement('div');
    track.className = 'card-media-track';

    var matched = 0;
    for (i = 0; i < images.length; i++) {
      var imgColor = colors[i];
      var sep = images[i].indexOf('?') > -1 ? '&' : '?';
      var img = document.createElement('img');
      img.className = 'card-media-slide';
      img.setAttribute('data-color', imgColor);
      img.alt = product.title || '';
      img.loading = 'eager';
      img.src = images[i] + sep + 'width=533';
      img.setAttribute('srcset',
        images[i] + sep + 'width=360 360w, ' +
        images[i] + sep + 'width=533 533w, ' +
        images[i] + sep + 'width=720 720w');
      img.setAttribute('sizes', '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw');
      if (canFilter && imgColor !== defaultColor) img.style.display = 'none';
      else matched++;
      track.appendChild(img);
    }

    slider.appendChild(track);
    var dots = document.createElement('div');
    dots.className = 'card-media-dots';
    slider.appendChild(dots);
    host.appendChild(slider);
/* pre-decode so no slide is ever blank mid-cycle */
Array.prototype.forEach.call(track.querySelectorAll('img'), function (im) {
  if (im.decode) im.decode().catch(function () {});
});
    log('slider built — color option:', colorIdx,
        '— default color:', JSON.stringify(defaultColor),
        '— images:', images.length,
        '— in default group:', matched);
    return true;
  }

  /* ---------- color filtering ---------- */

  function applyColor(card, colorValue) {
    var slider = card.querySelector('.card-media-slider');
    if (!slider) return;
    var colorOpt = slider.getAttribute('data-color-option');
    if (!colorOpt || colorOpt === '0' || slider.hasAttribute('data-no-filter')) return;
    var track = card.querySelector('.card-media-track');
    if (!track) return;

    var target = (colorValue || '').toLowerCase().trim();

    if (target) {
      card.dataset.activeColor = target;
      Array.prototype.forEach.call(track.children, function (slide) {
        slide.style.display = (slide.getAttribute('data-color') === target) ? '' : 'none';
      });
      if (visibleSlides(track).length === 0) {
        log('no slides tagged "' + target + '" — slide colors are:', slideColors(track));
        delete card.dataset.activeColor;
        Array.prototype.forEach.call(track.children, function (slide) {
          slide.style.display = '';
        });
      }
    } else {
      delete card.dataset.activeColor;
      Array.prototype.forEach.call(track.children, function (slide) {
        slide.style.display = '';
      });
    }

    if (active && active.card === card) {
      active.index = 0;
      active.track.style.transform = 'translateX(0)';
      active.slides = visibleSlides(track);
      if (active.slides.length < 2) {
        stop();
        clearDots(card);
      } else {
        active.dots = buildDots(card, active.slides.length);
      }
    } else {
      clearDots(card);
    }
  }

  function currentColor(card) {
    if (card.dataset.activeColor) return card.dataset.activeColor;

    var slider = card.querySelector('.card-media-slider');
    if (!slider) return '';
    var co = slider.getAttribute('data-color-option');

    if (co && co !== '0') {
      var sel = card.querySelector('.spf-product__swatch.is-selected[data-option="' + co + '"]');
      if (sel) return (sel.getAttribute('data-option-value') || '').toLowerCase().trim();

      var input = card.querySelector('input[name$="option[' + co + ']"]:checked');
      if (input) return (input.value || '').toLowerCase().trim();
    }

    return (slider.getAttribute('data-default-color') || '').toLowerCase().trim();
  }

  function stop() {
    if (!active) return;
    clearInterval(active.timer);
    active.track.style.transform = 'translateX(0)';
    if (active.slider) active.slider.classList.remove('is-on');
    active.dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === 0);
    });
    active = null;
  }

  /* ---------- start / stop ---------- */

  function startFor(card) {
    if (active && active.card === card) return;
    stop();

    var slider = card.querySelector('.card-media-slider');
    var track = card.querySelector('.card-media-track');

    /* markup missing (app-rendered grid) -> build it from product JSON first */
    if (!slider || !track || !track.children.length) {
      var handle = handleFromCard(card);
      if (!handle) { log('no product handle found in card:', card); return; }
      if (card.dataset.sliderLoading === '1') return;
      card.dataset.sliderLoading = '1';
      log('markup missing — fetching /products/' + handle + '.js');
      fetchProduct(handle, function (p) {
        delete card.dataset.sliderLoading;
        if (!p) { log('fetch failed for', handle); return; }
        if (!document.contains(card)) { log('card removed before build'); return; }
        if (buildSlider(card, p)) startFor(card);
        else log('build skipped — fewer than 2 images');
      });
      return;
    }

    var color = currentColor(card);
    log('hover — color:', JSON.stringify(color));
    applyColor(card, color);

    track = card.querySelector('.card-media-track');
    if (!track) return;
    var slides = visibleSlides(track);
    log('visible slides:', slides.length, '/', track.children.length);
    if (slides.length < 2) return;

    slider.classList.add('is-on');

    active = {
      card: card,
      slider: slider,
      track: track,
      slides: slides,
      dots: buildDots(card, slides.length),
      index: 0,
      timer: setInterval(function () {
        active.index = (active.index + 1) % active.slides.length;
        active.track.style.transform = 'translateX(-' + (active.index * 100) + '%)';
        active.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active.index);
        });
      }, AUTOPLAY_MS)
    };
  }

  /* ---------- events (capture phase — survive AJAX re-renders) ---------- */

  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches || !e.target.closest) return;
    var card = findCard(e.target);
    if (card) startFor(card);
  }, true);

  document.addEventListener('mouseout', function (e) {
    if (!active || !e.target.closest) return;
    var card = findCard(e.target);
    if (card === active.card && !(e.relatedTarget && active.card.contains(e.relatedTarget))) {
      stop();
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('.spf-product__swatch');
    if (!sw) return;
    var card = findCard(sw);
    if (!card) return;
    var val = (sw.getAttribute('data-option-value') || '').toLowerCase().trim();
    var slider = card.querySelector('.card-media-slider');
    if (slider) {
      var co = slider.getAttribute('data-color-option');
      if (!co || co === '0' || co !== sw.getAttribute('data-option')) return;
      log('swatch click — color:', val);
    }
    if (val) card.dataset.activeColor = val;
    if (slider) applyColor(card, val);
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.closest) return;
    var card = findCard(input);
    if (!card) return;
    var slider = card.querySelector('.card-media-slider');
    if (!slider) return;
    var co = slider.getAttribute('data-color-option');
    if (!co || co === '0') return;
    var name = input.getAttribute('name') || '';
    if (name.indexOf('option[' + co + ']') !== -1 && input.checked) {
      applyColor(card, input.value);
    }
  }, true);

  /* ---------- console API for testing ---------- */
  window.CardSlider = {
    version: VERSION,
    find: findCard,
    stop: stop,
    start: function (el) { var c = findCard(el); if (c) { startFor(c); return c; } return null; },
    status: function () {
      var sliders = document.querySelectorAll('.card-media-slider');
      console.log('[card-slider] sliders in DOM:', sliders.length);
      Array.prototype.forEach.call(sliders, function (s, i) {
        var track = s.querySelector('.card-media-track');
        console.log('  #' + i,
          'host:', s.parentElement && s.parentElement.className,
          '| slides:', track ? track.children.length : 0,
          '| color-opt:', s.getAttribute('data-color-option'),
          '| default:', s.getAttribute('data-default-color'),
          '| visible:', s.classList.contains('is-on'));
      });
      return sliders.length;
    },
    test: function () {
      var link = document.querySelector('a[href*="/products/"]');
      if (!link) { console.log('[card-slider] test: no product link on page'); return null; }
      var c = findCard(link);
      console.log('[card-slider] test: card =', c);
      if (c) startFor(c);
      return c;
    }
  };
})();